<template>
  <div>
    <i class="fa fa-check green" v-if="progress === true"></i>
    <i class="fa fa-remove red" v-else-if="progress === false"></i>
    <i class="fa fa-clock orange" v-else-if="progress === null"></i>
    <span v-else>{{ progress }}</span>

  </div>
</template>
<script>
export default {
  props: ['progress']
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/PageEntity/ProgressBar.vue